export const vertexShader = `
    attribute float aScale;
    varying vec3 vColor;

    void main() {
        vec4 modelPosition = modelMatrix * vec4(position, 1.0);
        vec4 viewPosition = viewMatrix * modelPosition;
        vec4 projectedPosition = projectionMatrix * viewPosition;

        gl_Position = projectedPosition;
        gl_PointSize = aScale * 100.0 / -viewPosition.z;
        vColor = color;
    }
`;

export const fragmentShader = `
    varying vec3 vColor;

    void main() {
        float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
        float strength = 0.05 / distanceToCenter - 0.1;

        gl_FragColor = vec4(vColor, strength);
    }
`;